/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: e0df96bf27cecba3b0e19a269be5fad5bedc28b4bbf3d99c89800dc2f5ca720c
 */
import { css } from 'styled-components'

export default css`
  display: inline-flex;
  position: relative;

  .menu {
    position: absolute;
    z-index: 1;
  }

  .menu.bottom-start {
    left: 0;
    margin-top: 4px;
    top: 100%;
  }

  .menu.bottom-end {
    margin-top: 4px;
    right: 0;
    top: 100%;
  }

  .menu.top-start {
    bottom: 100%;
    left: 0;
    margin-bottom: 4px;
  }

  .menu.top-end {
    bottom: 100%;
    margin-bottom: 4px;
    right: 0;
  }
`
